/*
 * @providesModule LTOUtils
 */

import _ from 'lodash';
import {LTOInfo} from 'StoreInfo';
import NetClient from 'NetClient';
import {ServerError} from 'SharedTypes';

import {NativeModules, Platform} from 'react-native';

const SKZAPIManager = NativeModules.SKZAPIManager;

type LTOTriggerResponse = {
  id: number,
  user_id: number,
  offer_id: number,
  triggered_count: number,
  start: string,
  end: string,
};

class LTOUtils {
  triggerLTO(ltoInfo: LTOInfo): Promise<LTOInfo> {
    return new Promise((resolve: (ltoInfo: LTOInfo)=>void, reject: (error: ServerError)=>void) => {
      NetClient.postURL(`store/offers/${ltoInfo.id}/triggers`, null, SKZAPIManager.OnError.failSilently, (error: ServerError, response: LTOTriggerResponse) => {
        if (error) {
          console.debug('LTOUtils: triggering LTO failed with error: ' + JSON.stringify(error));
          reject(error);
        } else {
          console.debug('LTOUtils: triggering LTO succeeded with response: ' + JSON.stringify(response));
          resolve(this._processLTOResponse(ltoInfo, response));
        }
      });
    });
  }

  _processLTOResponse(originalLTOInfo: LTOInfo, triggerResponse: LTOTriggerResponse) {
    const ltoInfo = {...originalLTOInfo};
    ltoInfo.end = triggerResponse.end;
    return ltoInfo;
  }

  // TODO: fix all the types in this file (Object is a cop-out)

  _determineOfferToDisplay(storeInfo: Object, isCash: boolean): Object {
    // TODO (websdk-post-mvp): Switch back to limited_time_offers when proper api version is available
    const offers =
        Platform.OS === 'web' ?
            [_.get(storeInfo, 'limited_time_offer', {})] :
            _.get(storeInfo, 'limited_time_offers', []);
    if (offers && offers !== []) {
      const triggeredOffer = this._getOfferToDisplay(offers);
      if (triggeredOffer) {
        return triggeredOffer;
      } else {
        return this._triggerAppropriateOffer(offers, isCash);
      }
    } else {
      return {};
    }
  }

  _getOfferToDisplay(offers: Array<Object>): Object {
    if (offers && offers !== []) {
      const triggeredOffer = this._filterTriggeredOffer(offers);
      if (triggeredOffer && this._isValidOffer(triggeredOffer)) {
        return triggeredOffer;
      }
      return null;
    }
  }

  _filterTriggeredOffer(offers: Array<Object>): Object {
    let triggeredOffer = {};
    _.forEach(offers, (offer: Object) => {
      if (offer.end) {
        triggeredOffer = offer;
      }
    });
    return triggeredOffer;
  }

  _isValidOffer(offer: any): boolean {
    // Triggered offers will have an End Date, untriggered will be null.
    const now = new Date();
    const end = new Date (offer.end);
    return end > now;
  }

  _triggerAppropriateOffer(offers: Array<Object>, isCash: boolean): Object {
    return this._findAppropriateOfferToTrigger(offers, isCash);
  }

  _findAppropriateOfferToTrigger(offers: Array<Object>, isCash: boolean): Object {
    let offer = null;
    offer = _.find(offers, {type:'FIRST_TIME_USER'});
    if (!offer) {
      if (isCash) {
      // Cash Depleted can only be triggered on InsufficientFunds;
      offer = _.find(offers, {type: 'CASH_DEPLETED'});
      }
      // If no InsufficientFunds offer, fallback to ALL
      if (!offer) {
        offer = _.find(offers, {type: 'ALL'});
      }
    }
    return offer;
  }
}

export default new LTOUtils();
